import UtmList from './UtmListContainer';

export default UtmList;
